module.exports = __webpack_public_path__ + "img/07医学院.9687e812.png";